import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { FormlyModule } from '@ngx-formly/core';

import { TaFormlyFieldWrapperModule } from '@ta-formly/ta-field-wrapper/ta-field-wrapper.module';
import { TaOilLevelGaugeComponent } from './ta-oil-level-gauge.type';

@NgModule({
    declarations: [TaOilLevelGaugeComponent],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        IonicModule,
        TaFormlyFieldWrapperModule,
        FormlyModule.forChild({
            types: [
                {
                    name: 'ta-oil-level-gauge',
                    component: TaOilLevelGaugeComponent,
                    wrappers: ['ta-field-wrapper']
                }
            ]
        })
    ]
})
export class TaFormlyOilLevelGaugeModule { }
